"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./NavTabs.css");
var Button_1 = require("../button/Button");
var react_router_dom_1 = require("react-router-dom");
var Link_1 = require("../link/Link");
var Dropdown_1 = require("../dropdown/Dropdown");
var Listbox_1 = require("../listbox/Listbox");
var string_1 = require("../../utils/string");
var Icon_1 = require("../icon/Icon");
var useOnTabOutside_1 = require("../../hooks/useOnTabOutside");
var keyboard_1 = require("../../utils/dom/keyboard");
var touch_1 = require("../../utils/dom/touch");
var NavTabsOverflowDirection;
(function (NavTabsOverflowDirection) {
    NavTabsOverflowDirection["NONE"] = "None";
    NavTabsOverflowDirection["BOTH"] = "Both";
    NavTabsOverflowDirection["RIGHT"] = "Right";
    NavTabsOverflowDirection["LEFT"] = "Left";
})(NavTabsOverflowDirection = exports.NavTabsOverflowDirection || (exports.NavTabsOverflowDirection = {}));
var NavTabsType;
(function (NavTabsType) {
    NavTabsType["section"] = "section";
    NavTabsType["subsection"] = "subsection";
    NavTabsType["vertical"] = "vertical";
})(NavTabsType = exports.NavTabsType || (exports.NavTabsType = {}));
var NavTabsComp = function (props) {
    var htmlProps = (function (_a) {
        var tabs = _a.tabs, index = _a.index, startIndex = _a.startIndex, subIndex = _a.subIndex, startSubIndex = _a.startSubIndex, type = _a.type, dismissDropdownOnChange = _a.dismissDropdownOnChange, onTabClick = _a.onTabClick, onChange = _a.onChange, onDropdownChange = _a.onDropdownChange, rest = __rest(_a, ["tabs", "index", "startIndex", "subIndex", "startSubIndex", "type", "dismissDropdownOnChange", "onTabClick", "onChange", "onDropdownChange"]);
        return rest;
    })(props);
    //--- states ---//
    var _a = __read(react_1.useState(-1), 2), curIndex = _a[0], setCurIndex = _a[1];
    var _b = __read(react_1.useState(-1), 2), curSubIndex = _b[0], setCurSubIndex = _b[1];
    var _c = __read(react_1.useState(-1), 2), focussedIndex = _c[0], setFocussedIndex = _c[1];
    var _d = __read(react_1.useState(NavTabsOverflowDirection.NONE), 2), scrollOverflowDirection = _d[0], setScrollOverflowDirection = _d[1];
    var _e = __read(react_1.useState(''), 2), redirectRoute = _e[0], setRedirectRoute = _e[1];
    //--- refs ---//
    var el = react_1.useRef(null);
    var scrollEl = react_1.useRef(null);
    //--- effects ---//
    useOnTabOutside_1.useOnTabOutside(el, function (e) {
        setFocussedIndex(-1);
    });
    react_1.useEffect(function () {
        //update scroll overflow
        window.addEventListener('resize', onResize);
        onResize();
        //set selected tab and subtab
        var index = props.index === undefined ? props.startIndex : props.index;
        if (props.index === undefined)
            updateNotDisabledTab(props.startIndex);
        if (props.subIndex === undefined)
            updateNotDisabledSubTab(index, props.startSubIndex);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    react_1.useEffect(function () {
        updateNotDisabledTab(props.index);
    }, [props.index, props.tabs]);
    react_1.useEffect(function () {
        updateNotDisabledSubTab(curIndex, props.subIndex);
    }, [props.subIndex, curIndex]);
    react_1.useEffect(function () {
        if (redirectRoute)
            setRedirectRoute('');
    }, [redirectRoute]);
    //--- utility methods ---//
    function updateNotDisabledTab(index) {
        if (index === undefined)
            return;
        var notDisabledIndex = getNotDisabledTabIndex(index);
        setCurIndex(notDisabledIndex);
        if (!touch_1.getIsUsingMouse())
            setFocussedIndex(notDisabledIndex);
        var notDisabledTab = props.tabs[notDisabledIndex];
        if (notDisabledIndex !== index) {
            if (notDisabledTab &&
                !notDisabledTab.dropdownOptions &&
                notDisabledTab.route)
                setRedirectRoute(string_1.cleanPath(notDisabledTab.route));
            if (props.onChange)
                props.onChange(notDisabledTab, notDisabledIndex, null);
        }
    }
    function updateNotDisabledSubTab(index, subIndex) {
        if (index === undefined || subIndex === undefined)
            return;
        var notDisabledIndex = getNotDisabledTabIndex(index);
        var options = props.tabs && props.tabs[notDisabledIndex]
            ? props.tabs[notDisabledIndex].dropdownOptions
            : [];
        if (options && options.length > 0) {
            var notDisabledSubIndex = subIndex === -1
                ? subIndex
                : subIndex < options.length
                    ? getNotDisabledIndex(subIndex, options)
                    : getNotDisabledIndex(options.length - 1, options);
            setCurSubIndex(notDisabledSubIndex);
            if (notDisabledSubIndex !== subIndex) {
                var notDisabledOption = options[notDisabledSubIndex];
                if (notDisabledOption && notDisabledOption.route) {
                    setRedirectRoute(string_1.cleanPath(notDisabledOption.route));
                }
                if (props.onDropdownChange)
                    props.onDropdownChange(notDisabledOption, notDisabledSubIndex, null);
            }
        }
    }
    function getNotDisabledTabIndex(index) {
        return index === undefined || index === -1
            ? index
            : index < props.tabs.length
                ? getNotDisabledIndex(index, props.tabs)
                : getNotDisabledIndex(props.tabs.length - 1, props.tabs);
    }
    function getNotDisabledIndex(startIndex, items, direction) {
        if (direction === void 0) { direction = 'forward'; }
        var endIndex = startIndex;
        var i = 0;
        function checkDisabled(index) {
            var length = items.length - 1;
            if (items[index].disabled) {
                if (i < length) {
                    i++;
                    if (direction === 'backward') {
                        if (index > 0)
                            checkDisabled(index - 1);
                        else
                            checkDisabled(length);
                    }
                    else {
                        if (index < length)
                            checkDisabled(index + 1);
                        else
                            checkDisabled(0);
                    }
                }
                else {
                    endIndex = -1;
                }
            }
            else {
                endIndex = index;
            }
        }
        if (items.length > 0)
            checkDisabled(endIndex);
        return endIndex;
    }
    function updateScrollOverflow(el) {
        var direction;
        //1 pixel buffer to account for any discrepancies between scrollWidth and clientWidth which happen due to rounding during calculations
        if (el.scrollWidth - el.clientWidth > 1) {
            var pos = el.scrollLeft;
            direction =
                pos <= 0
                    ? NavTabsOverflowDirection.RIGHT
                    : pos >= el.scrollWidth - el.clientWidth
                        ? NavTabsOverflowDirection.LEFT
                        : NavTabsOverflowDirection.BOTH;
        }
        else
            direction = NavTabsOverflowDirection.NONE;
        setScrollOverflowDirection(direction);
    }
    //--- callback methods ---//
    function onResize() {
        if (scrollEl.current)
            updateScrollOverflow(scrollEl.current);
    }
    function onTabClick(tab, index, e) {
        if (props.index === undefined) {
            setCurIndex(index);
            if (!touch_1.getIsUsingMouse())
                setFocussedIndex(index);
        }
        if (props.onTabClick)
            props.onTabClick(tab, index, e);
        if (props.onChange)
            props.onChange(tab, index, e);
    }
    var onKeyDown = function (e) {
        var _a;
        var tabs = (_a = el.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.NavTabs_list > li [role="tab"]');
        var tabHasFocus = tabs[focussedIndex] === document.activeElement;
        if (!tabHasFocus)
            return; //prevent arrow key functionality if child of tab is focussed (dropdown list item)
        if (keyboard_1.isKeyArrowLeft(e) || keyboard_1.isKeyArrowUp(e)) {
            var startIndex = focussedIndex > 0 ? focussedIndex - 1 : props.tabs.length - 1;
            var index = getNotDisabledIndex(startIndex, props.tabs, 'backward');
            var tab = tabs[index];
            tab.focus();
        }
        if (keyboard_1.isKeyArrowRight(e) || keyboard_1.isKeyArrowDown(e)) {
            var startIndex = focussedIndex < props.tabs.length - 1 ? focussedIndex + 1 : 0;
            var index = getNotDisabledIndex(startIndex, props.tabs);
            var tab = tabs[index];
            tab.focus();
        }
    };
    var onTabLinkFocussed = function (e, tabIndex) {
        setFocussedIndex(tabIndex);
    };
    return (React.createElement(React.Fragment, null,
        redirectRoute && React.createElement(react_router_dom_1.Redirect, { to: redirectRoute }),
        React.createElement("div", __assign({}, htmlProps, { ref: el, className: classnames_1.default('NavTabs', htmlProps.className, "NavTabs-overflow" + scrollOverflowDirection, "NavTabs-" + props.type), onKeyDown: onKeyDown, onBlur: function (e) { return onTabLinkFocussed(e, -1); } }),
            React.createElement("ul", { "aria-label": 'Navigation tabs', "aria-orientation": props.type === NavTabsType.vertical ? 'vertical' : undefined, role: 'tablist', className: 'NavTabs_list', ref: scrollEl, onScroll: function () {
                    if (scrollEl.current)
                        updateScrollOverflow(scrollEl.current);
                } }, props.tabs.map(function (tab, index) { return (React.createElement("li", { key: index, role: 'presentation', className: classnames_1.default('NavTabs_tab', tab.className, {
                    'NavTabs_tab-focus': index === focussedIndex,
                    'NavTabs_tab-active': index === curIndex,
                    'NavTabs_tab-disabled': tab.disabled,
                }) }, tab.dropdownOptions ? (React.createElement(Dropdown_1.Dropdown, { role: 'presentation', className: 'NavTabs_dropdown', label: tab.label, dismissOnChange: props.dismissDropdownOnChange, icon: Icon_1.IconType.chevronDown, overlay: false, theme: Dropdown_1.DropdownTheme.none, buttonProps: {
                    role: 'tab',
                    'aria-label': typeof tab.label === 'string' ? tab.label : undefined,
                    'aria-selected': index === curIndex,
                    tabIndex: index === curIndex || index === focussedIndex ? 0 : -1,
                    onFocus: function (e) { return onTabLinkFocussed(e, index); },
                } },
                React.createElement(Listbox_1.Listbox, { className: 'NavTabs_dropdownList', options: tab.dropdownOptions, index: curIndex === index ? curSubIndex : -1, theme: Listbox_1.ListboxTheme.compact, onChange: function (option, optionIndex, e) {
                        if (curIndex !== index)
                            onTabClick(tab, index, e);
                        if (props.subIndex === undefined)
                            setCurSubIndex(optionIndex);
                        if (props.onDropdownChange)
                            props.onDropdownChange(tab, optionIndex, e);
                    } }))) : tab.route ? (React.createElement(Link_1.Link, { role: "tab", tabIndex: index === curIndex ? 0 : -1, "aria-selected": index === curIndex, className: classnames_1.default('NavTabs_tabLink Button', {
                    'Button-disabled': tab.disabled,
                }), to: tab.route, disabled: tab.disabled, onFocus: function (e) { return onTabLinkFocussed(e, index); }, onClick: function (e) { return onTabClick(tab, index, e); } },
                React.createElement("span", { className: 'NavTabs_tabLinkLabel' }, tab.label))) : (React.createElement(Button_1.Button, { role: "tab", tabIndex: index === curIndex ? 0 : -1, "aria-selected": index === curIndex, className: "NavTabs_tabLink", disabled: tab.disabled, onFocus: function (e) { return onTabLinkFocussed(e, index); }, onClick: function (e) { return onTabClick(tab, index, e); } },
                React.createElement("span", { className: 'NavTabs_tabLinkLabel' }, tab.label))))); })),
            (scrollOverflowDirection === NavTabsOverflowDirection.BOTH ||
                scrollOverflowDirection === NavTabsOverflowDirection.LEFT) && (React.createElement("div", { className: 'NavTabs_overflowLeft' })),
            (scrollOverflowDirection === NavTabsOverflowDirection.BOTH ||
                scrollOverflowDirection === NavTabsOverflowDirection.RIGHT) && (React.createElement("div", { className: 'NavTabs_overflowRight' })))));
};
NavTabsComp.defaultProps = {
    type: NavTabsType.section,
    dismissDropdownOnChange: true,
    startIndex: -1,
    startSubIndex: -1,
};
exports.NavTabs = React.memo(NavTabsComp);
